 // map some common timezones to representative city coordinates (lat,lng,zoom)
 export const timezoneToCoords = tz => {
    if (!tz || typeof tz !== 'string') return null;
    const map = {
      'Asia/Dhaka': { lat: 23.8103, lng: 90.4125, zoom: 12 },
      'Asia/Kolkata': { lat: 22.5726, lng: 88.3639, zoom: 12 },
      'Asia/Karachi': { lat: 24.8607, lng: 67.0011, zoom: 12 },
      'Asia/Hanoi': { lat: 21.0278, lng: 105.8342, zoom: 12 },
      'Asia/Ho_Chi_Minh': { lat: 10.8231, lng: 106.6297, zoom: 12 },
      'Asia/Jakarta': { lat: -6.2088, lng: 106.8456, zoom: 12 },
      'Asia/Tokyo': { lat: 35.6762, lng: 139.6503, zoom: 12 },
      'Europe/London': { lat: 51.5074, lng: -0.1278, zoom: 12 },
      'America/New_York': { lat: 40.7128, lng: -74.006, zoom: 12 },
      'America/Los_Angeles': { lat: 34.0522, lng: -118.2437, zoom: 12 },
      'Australia/Sydney': { lat: -33.8688, lng: 151.2093, zoom: 12 },
      // add more as needed
    };
    return map[tz] || null;
  };